import React from "react";
import ReactDOM from "react-dom";
import {Provider} from './components/utils.jsx';
import poly from "poly-js-utils";
import css from "./common/dynamic-css-loader.js";
import ProductsPage from "./components/products_page";

poly.KalturaHelpers.init();
css.loadDynamicCss();

ReactDOM.render(
    <Provider JSContext={window.JSContext}>
        <ProductsPage />
    </Provider>,
    document.getElementById('products')
);



// WEBPACK FOOTER //
// ./products.js